<template lang="pug">
    v-card( dark )
        v-card-text.py-5
            h1.display-2 Modulo de Finanzas
            p.subheading.ma-0 Tesorería, Cobranza, Recursos Humanos y Contabilidad
</template>

<script>
    //
    import { mapActions } from "vuex"
    //
    export default {
        name: "index-component",
        methods: {

            //
            ...mapActions( "MenuesModule", {
                setTitleTopBar: "setTitleTopBar",
            }),

        },
        mounted () {
            this.setTitleTopBar( "Bienvenido" )
        },
    }
</script>